<template>
  <div
    :style="{ ...options.wrapper, order: this.options.position }"
    v-indicator="{ id, setActive }"
    :class="[`tabs_${id}`, { active: isActive(id) }]"
  >
    <div class="information">{{ info }}<i class="fas fa-hand-pointer" @click.stop="setActive(id)"></i></div>
    <div class="desktop-content" :class="[currentView === 'lg' ? 'd-block' : 'd-none']">
      <template v-for="(tab, index) in current.items">
        <div :key="tab.id" :style="{ ...options.content, display: selectedIndex === index ? 'block' : 'none' }">
          <Section :id="current.children[index]" />
        </div>
      </template>
    </div>
    <div :style="options.sidenav">
      <h4 class="font-weight-light mb-4">{{ current.title }}</h4>
      <div
        v-for="(tab, index) in current.items"
        :key="tab.id"
        class="tab d-flex mb-3 tabs-item-container"
        :class="[currentView === 'lg' ? 'flex-row' : 'flex-column']"
        @click="selectedIndex = index"
      >
        <div class="d-flex flex-column" :class="[currentView === 'lg' ? 'mr-3' : 'mr-0']">
          <div class="d-flex justify-content-center" :class="[currentView === 'lg' ? 'flex-column' : 'flex-row']">
            <div
              class="d-flex align-items-center justify-content-center mb-2"
              :class="[currentView === 'lg' ? 'mr-0' : 'mr-2']"
            >
              <div class="mr-2" v-html="getCalendarSvg(tab.options[currentView].dateColor)" />
              <h1 class="mb-0" :style="{ color: tab.options[currentView].dateColor }">
                {{ getDatetime(tab) | moment('DD') }}
              </h1>
            </div>
            <div class="d-flex flex-column">
              <p class="mb-0" :style="{ color: tab.options[currentView].dateColor }">
                <strong>{{ getDatetime(tab) | moment('MMM HH:mm') }}</strong>
              </p>
              <p class="mb-2" :style="{ color: tab.options[currentView].dateColor }">
                {{ getDatetime(tab) | moment('YYYY') }}
              </p>
            </div>
          </div>
          <button class="tab-button bg-white">
            {{ tab.button }}
          </button>
        </div>
        <div class="d-flex flex-column" :class="[currentView === 'lg' ? 'text-left' : 'text-center']">
          <p class="my-2">{{ tab.title }}</p>
          <p class="tab-description font-weight-bold">
            {{ tab.description }}
          </p>
        </div>
        <Section :class="[currentView === 'lg' ? 'd-none' : 'd-block']" :id="current.children[index]" />
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from '@/components/page-editor/Mixin.js'
import Section from '@/components/page-editor/Section'
import moment from 'moment-timezone'

export default {
  mixins: [Mixin],
  components: { Section },
  data() {
    return {
      selectedIndex: 0,
    }
  },
  computed: {
    info() {
      const tabItems = this.current.children.length
      const info = tabItems
        ? `${tabItems} ${this.$i18n.t('components.page-editor.tabs.tab/tabs')}`
        : this.$i18n.t('components.page-editor.tabs.empty')
      return `${this.current.title}${info && ` - ${info}`}`
    },
  },
  methods: {
    getDatetime(tabItem) {
      return moment(`${tabItem.date}T${tabItem.time}`, 'YYYY-MM-DDTHH:mm:ss')
    },
    getCalendarSvg(color) {
      return `<svg width="38" height="42" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M29.3148 5.25H33.3123C35.5201 5.25 37.3098 7.01285 37.3098 9.1875V38.0625C37.3098 40.2371 35.5201 42 33.3123 42H3.99748C1.7897 42 0 40.2371 0 38.0625V9.1875C0 7.01285 1.7897 5.25 3.99748 5.25H7.99495V0.984375C7.99495 0.440754 8.44242 0 8.99432 0H9.66057C10.2125 0 10.6599 0.440754 10.6599 0.984375V5.25H26.6498V0.984375C26.6498 0.440754 27.0973 0 27.6492 0H28.3155C28.8674 0 29.3148 0.440754 29.3148 0.984375V5.25ZM33.3123 7.875H3.99747C3.26277 7.875 2.66498 8.46382 2.66498 9.1875V13.125H34.6448V9.1875C34.6448 8.46382 34.047 7.875 33.3123 7.875ZM33.3123 39.375H3.99747C3.26277 39.375 2.66498 38.7862 2.66498 38.0625V15.75H34.6448V38.0625C34.6448 38.7862 34.047 39.375 33.3123 39.375ZM16.5514 34.3525L27.7769 23.3841C28.169 23.0009 28.1716 22.3771 27.7825 21.9908L27.0781 21.2914C26.6891 20.9051 26.0558 20.9026 25.6636 21.2858L15.8546 30.8701L11.6538 26.7204C11.2638 26.3351 10.6305 26.3342 10.2394 26.7184L9.53106 27.414C9.13997 27.7983 9.13906 28.422 9.52906 28.8073L15.1387 34.3487C15.528 34.7333 16.16 34.735 16.5514 34.3525Z" fill="${color}"/>
              </svg>`
    },
  },
}
</script>

<style lang="scss" scoped>
[class^='tabs_'] {
  position: relative;

  > .information {
    display: none;
    position: absolute;
    bottom: 0px;
    right: 0px;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    z-index: 200;
    background: var(--indicator-active);
    cursor: pointer;
  }

  &:hover,
  &.active {
    box-shadow: inset 0 0 0px 2px var(--indicator-active);
    > .information {
      display: block;
    }
  }

  .desktop-content {
    flex: 2;
  }

  .tabs-item-container {
    cursor: pointer;
  }

  .tab-button {
    border: 2px solid #a8a8a8;
    color: #a8a8a8;
  }

  .tab-description {
    line-height: 150%;
  }
}
</style>
